var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "preview-wrapper"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "color",
    style: {
      'background-color': _vm.formValue
    }
  }), _vm.placeholder ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "picker-grow"
    }
  }, [_vm.show ? _c('div', {
    staticClass: "picker"
  }, _vm._l(_vm.swatches, function (swatch) {
    return _c('div', {
      key: swatch,
      staticClass: "swatch",
      style: {
        'background-color': swatch
      },
      on: {
        "click": function click($event) {
          return _vm.select(swatch);
        }
      }
    });
  }), 0) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }